import { render, staticRenderFns } from "./Rol.vue?vue&type=template&id=497141ca"
import script from "./Rol.vue?vue&type=script&lang=ts"
export * from "./Rol.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports